import {
  Avatar,
  Image,
  makeStyles,
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  tokens,
} from "@fluentui/react-components";
import { Chat16Regular, Home16Regular } from "@fluentui/react-icons";
import { useAtom } from "jotai";
import * as React from "react";
import { activeTabAtom } from "@/state";
import type { TabName, User } from "@/types";

type Props = {
  user: User | undefined;
  showTabs?: boolean;
};

export default function AppHeader(props: Props) {
  const styles = useStyles();
  const [activeTab, setActiveTab] = useAtom(activeTabAtom);

  const handleTabSelect = (_: SelectTabEvent, data: SelectTabData) => {
    setActiveTab(data.value as TabName);
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftSection}>
        <Image src="/assets/aiir-logo.svg" alt="Aiir logo" width={"48px"} height={"48px"} />
        {props.showTabs && (
          <div className={styles.tabsScrollContainer}>
            <TabList className={styles.tabList} selectedValue={activeTab} onTabSelect={handleTabSelect} size="small">
              <Tab id="Home" icon={<Home16Regular />} value="home" className={styles.tab}>
                Home
              </Tab>
              <Tab id="Chat" icon={<Chat16Regular />} value="chat" className={styles.tab}>
                Chat
              </Tab>
            </TabList>
          </div>
        )}
      </div>

      <div className={styles.rightSection}>
        <Avatar
          initials={props.user ? props.user.firstName?.charAt(0) + props.user.lastName?.charAt(0) : ""}
          active="active"
          color={"lavender"}
          size={28}
          className={styles.avatar}
        />
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: "12px",
    paddingRight: "12px",
    paddingTop: "2px",
    paddingBottom: "2px",
    backgroundColor: tokens.colorNeutralBackground2,
    gap: "8px",
    minHeight: "auto",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
    zIndex: 2,
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexShrink: 0,
    zIndex: 2,
  },
  tabsScrollContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginLeft: "0",
    marginRight: "0",
  },
  tabList: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "8px",
    minWidth: "auto",
    paddingLeft: "0",
    paddingRight: "0",
  },
  tab: {
    fontSize: "11px",
    minWidth: "fit-content",
    paddingLeft: "8px",
    paddingRight: "8px",
    "& svg": {
      fontSize: "14px",
      width: "14px",
      height: "14px",
    },
  },
  avatar: {
    flexShrink: 0,
    zIndex: 2,
    width: "24px",
    height: "24px",
  },
});
